import Loading from '@/components/common/Loading'
import CardNotFound from '@/components/error/NotFound'
import BrandedToolbar, {
  isToolbarHidden
} from '@/components/Toolbar/BrandedToolbar'
import useBranding from '@/lib/useBranding'
import usePageParams from '@/lib/usePageParams'

export default function NotFoundRoute() {
  const pageParams = usePageParams()
  const hasCredentials = !!(
    pageParams.alias &&
    pageParams.sdkAppId &&
    pageParams.sdkAppKey
  )
  const { branding, isLoading } = useBranding(pageParams, 3, hasCredentials)

  if (hasCredentials && isLoading) {
    return <Loading />
  }

  // Without credentials there is nothing to brand against.
  const effectiveBranding = hasCredentials ? branding : null

  return (
    <>
      <BrandedToolbar branding={effectiveBranding} />
      <div
        className={`${isToolbarHidden(effectiveBranding) ? 'pt-0' : 'pt-[55px]'}`}>
        <CardNotFound
          withBackButton={
            effectiveBranding?.enabled &&
            !effectiveBranding?.feedHideGoBackToMainButton
          }
        />
      </div>
    </>
  )
}
